import { render, staticRenderFns } from "./PopularItem.vue?vue&type=template&id=3b408fdd&"
import script from "./PopularItem.vue?vue&type=script&lang=js&"
export * from "./PopularItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3b408fdd', component.options)
    } else {
      api.reload('3b408fdd', component.options)
    }
    module.hot.accept("./PopularItem.vue?vue&type=template&id=3b408fdd&", function () {
      api.rerender('3b408fdd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/PopularItem.vue"
export default component.exports